import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Landing from './pages/Landing';
import QuizLearn from './pages/Home'; // Your existing Quiz & Learn web app
import QuizLearnLanding from './pages/QuizLearnLanding'; // Dedicated detail page for Quiz & Learn
import NclexSmartPrep from './pages/NclexSmartPrep';
import PmhnpSmartPrep from './pages/PmhnpSmartPrep';
import CdipSmartPrep from './pages/CdipSmartPrep';
import KingdomKids from './pages/KingdomKids';
import RiseUp365 from './pages/RiseUp365';
import DailyGrace365 from './pages/DailyGrace365';
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quiz-learn" element={<QuizLearn />} />
        <Route path="/quiz-learn-info" element={<QuizLearnLanding />} />
        <Route path="/nclexsmart-prep" element={<NclexSmartPrep />} />
        <Route path="/pmhnp-smart-prep" element={<PmhnpSmartPrep />} />
        <Route path="/cdip-smart-prep" element={<CdipSmartPrep />} />
        <Route path="/kingdom-kids-daily-devotional" element={<KingdomKids />} />
        <Route path="/riseup-365" element={<RiseUp365 />} />
        <Route path="/daily-grace-365" element={<DailyGrace365 />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;